module.exports = __webpack_public_path__ + "img/Monte_Kope_97.61086920.jpg";